<!-- Translated: yes -->
<template>
  <div style="position:relative;">
    <OnSiteFooter v-if="$store.state.isOnSite" />
    <LanguageSwitcher type="dropdown" v-if="!$store.state.isOnSite" :show-title="false" @pickedlanguage="change" />

    <div class="header">
      <h2 v-if="isWinter">{{ $t('texts.texts-skischool-header-top-title') }}</h2>
      <h2 v-if="isSummer">Välj vilken cykelskola som passar dig bäst</h2>

      <div :class="{disabled: loading, notification: true, 'notification--transparent': true}" v-if="!isSummer">
        <b>{{ $t('texts.texts-skischool-header-title') }}</b>
        <p>{{ $t('texts.texts-skischool-header-text') }}</p>
      </div>
    </div>
    <div>
      <div class="center">
        <OutlineButton class="max-mobile" :label="$t('skischool.more-filters')" :closeLabel="$t('skischool.close-filters')" :class="{active: expanded}" icon="Filter" :iconscale="1.5" :status="expanded" @clicked="expanded = !expanded" />
      </div>
      <SkiSchoolFilter @change="change" :class="{disabled: loading, filter: true, opened: expanded}" :season="isSummer ? 'summer' : 'winter'" />

      <SkiSchoolFilterInfo @change="change" :count="count" />
    </div>

    <Loading :show="loading" :text="$t('skischool.applying-filters')" />
    <SkiSchoolList :data="data" :count="count" :class="{disabled: loading}" />
  </div>
</template>

<script>
import SkiSchoolList from '@/components/parts/SkiSchool/SkiSchoolList';
import SkiSchoolFilter from '@/components/parts/SkiSchool/SkiSchoolFilter';
import SkiSchoolFilterInfo from '@/components/parts/SkiSchool/SkiSchoolFilterInfo';
import Loading from '@/components/components/Loading';
import OutlineButton from '@/components/deprecated/OutlineButton';

import OnSiteFooter from '@/components/components/OnSiteFooter';

import LanguageSwitcher from '@/components/components/LanguageSwitcher';

import API from '@/classes/API';

import moment from 'moment';

import { mapMutations, mapGetters } from 'vuex';

export default {
  components: {
    SkiSchoolList,
    SkiSchoolFilter,
    SkiSchoolFilterInfo,
    Loading,
    OutlineButton,
    OnSiteFooter,
    LanguageSwitcher,
  },
  data() {
    return {
      data: [],
      count: 0,
      loading: false,
      expanded: false,
    };
  },
  mounted() {
    if (this.SITE_CONFIG.closed_modules.school) {
      this.openModal(['GeneralModal', {
        content: this.SITE_CONFIG.closed_modules.school,
        ok: () => {
          this.$router.go(-1);
        },
        closeModal: () => {
          this.$router.go(-1);
        },
      }]);
      return;
    }

    if (this.$route.query.type === 'snowboard') {
      for (let i in this.$store.state.skiSchoolFilter) { // eslint-disable-line
        if (this.$store.state.skiSchoolFilter[i]) { // eslint-disable-line
          if (i === 'date') { // eslint-disable-line
            this.$store.state.skiSchoolFilter[i] = null; // eslint-disable-line
          } else if (parseInt(i.substr(0, 1))) { // eslint-disable-line
            this.$store.state.skiSchoolFilter[i] = false; // eslint-disable-line
          } else { // eslint-disable-line
            this.$store.state.skiSchoolFilter[i] = false; // eslint-disable-line
          } // eslint-disable-line
        } // eslint-disable-line
      } // eslint-disable-line
    }

    this.change();
  },
  computed: {
    ...mapGetters([
      'isAwaitingFilter',
    ]),
    isWinter() {
      return this.$route.name === 'ski school overview';
    },
    isSummer() {
      return this.$route.name === 'bike school overview';
    },
  },
  methods: {
    ...mapMutations([
      'openModal',
    ]),
    openFaq() {
      this.openModal(['SkiSchoolFaq', {}]);
    },
    async change() {
      this.loading = true;
      let query = '';
      let date = '';

      for (let i in this.$store.state.skiSchoolFilter) { // eslint-disable-line
        if (this.$store.state.skiSchoolFilter[i]) { // eslint-disable-line
          if (i === 'date') { // eslint-disable-line
            date = moment(this.$store.state.skiSchoolFilter[i]).format('YYYY-MM-DD');
            query += `&date=${date}`; // eslint-disable-line
          } else if (parseInt(i.substr(0, 1))) { // eslint-disable-line
            query += `&ages[]=${i}`; // eslint-disable-line
          } else { // eslint-disable-line
            query += `&level[]=${i}`; // eslint-disable-line
          } // eslint-disable-line
        } // eslint-disable-line
      } // eslint-disable-line

      query += `&cat=${this.$route.query.type}`;

      const season = this.isSummer ? 'summer' : 'winter';

      const { data, count } = await API.get(`/skischool/search?${query}&group=1&btype=${season}`);
      this.data = data;
      this.count = count;
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.notification
  info-box()
  info-box--blue()
  margin 0 auto
  margin-top: 20px
  max-width 600px
  &.notification--transparent
    background-color transparent
    border 0
    margin-bottom 20px

.header
  padding-left: padding-mobile
  padding-right: padding-mobile
  +max-mobile()
    h2
      font-size: 18px!important

.disabled
  disabled-grey()

.items-list
  max-width 980px
  margin 0 auto

  .item
    display: flex
    justify-content: space-between
    flex-gutter: 1em
    background-color: white
    box-shadow: 0 0 17px 0 rgba(0, 0, 0, 0.13)
    padding: 15px 17px
    cursor: pointer
    margin-bottom: space-3

    ul
      ul-with-checkboxes()

    .item-image
      width: 30%
      height: 240px
      background-size: cover
      background-image: url(https://static.booking.branasgruppen.se/static/img/utkorning-kort-bg.jpg)

    .item-body
      flex-grow: 1
      display: flex
      flex-direction: column
      justify-content: space-between
      margin-left: space-2
      padding: space-2

    h2
      united-heavy()
      uppercase()
      font-size: size-font-headline-small
      +max-mobile()
        font-size: 18px!important

    ul
      li
        font-size: size-font-2
        margin-bottom: 12px

    button
      margin-top: space-2

h2
  united-heavy()
  uppercase()
  centered()
  color #262626
  font-size: size-font-headline-small
  margin-top: 25px
  margin-bottom: 20px
  filt
  +max-mobile()
    font-size: 18px!important

.filter
  display block
  +max-mobile()
    display none
    &.opened
      display block
      margin-top: 10px

.language-switcher
  position absolute
  right 10px
  top -15px
  width: auto
  display inline-block
  padding: 5px 10px;

</style>



// WEBPACK FOOTER //
// SkiSchoolOverview.vue?c26e76c8